import { render, staticRenderFns } from "./Supertable.vue?vue&type=template&id=a1751d66&scoped=true"
import script from "./Supertable.vue?vue&type=script&lang=js"
export * from "./Supertable.vue?vue&type=script&lang=js"
import style0 from "./Supertable.vue?vue&type=style&index=0&id=a1751d66&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1751d66",
  null
  
)

export default component.exports